import React from 'react';
import PropTypes from 'prop-types';

import { Label } from '@atlas/ui';

const FooterMenuList = ({ children, title }) => (
  <ul className="footer__menu__list">
    <li className="footer__menu__title">
      <Label className="block-title" message={title} />
    </li>
    {children}
  </ul>
);

FooterMenuList.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
};

export default FooterMenuList;
